export const SITE = {
  name: "Zelaya's Design INC",
  owner: "Santos Dario Zelaya",
  phone: "786-269-1230",
  phoneHref: "tel:+17862691230",
  email: "zelayastucco77@gmail.com",
  emailHref: "mailto:zelayastucco77@gmail.com",
  address: "4518 Fox Ridge Blvd, Wesley Chapel, FL 33543",
  yearsExperience: 10,
  warranty: "1 Year Warranty",
  // Placeholder — owner can swap with real Google Business review URL later.
  googleReviewUrl:
    "https://search.google.com/local/writereview?placeid=PLACEHOLDER_ZELAYA_DESIGN_INC",
};

export const TRUST_BADGES = [
  { label: "10 Years of Experience", icon: "Award" },
  { label: "1 Year Warranty", icon: "ShieldCheck" },
  { label: "Quality Work Guaranteed", icon: "BadgeCheck" },
  { label: "Customer Satisfaction", icon: "Star" },
  { label: "Residential & Commercial", icon: "Building2" },
];

export const SERVICES = [
  { slug: "interior-painting", title: "Interior Painting", icon: "PaintRoller", description: "Flawless interior finishes — walls, ceilings, trim and accent details with premium low-VOC paints.", span: 2 },
  { slug: "exterior-painting", title: "Exterior Painting", icon: "Home", description: "Weather-tested coatings that protect and elevate your home's curb appeal for years to come.", span: 1 },
  { slug: "stucco-repair", title: "Stucco Repair", icon: "Wrench", description: "Expert patching, crack repair and color-matched re-coats. Restore the original integrity.", span: 1 },
  { slug: "new-stucco", title: "New Stucco", icon: "Layers", description: "Full stucco systems and finishes for new construction and remodels in Wesley Chapel & beyond.", span: 1 },
  { slug: "remodeling", title: "Remodeling", icon: "Hammer", description: "Kitchens, baths and full interior remodels with detail-driven craftsmanship.", span: 2 },
  { slug: "pressure-washing", title: "Pressure Washing", icon: "Droplets", description: "Driveways, walls, roofs and patios — restored to a like-new finish.", span: 1 },
  { slug: "cabinet-painting", title: "Cabinet Painting", icon: "Square", description: "Factory-grade cabinet refinishing using durable, smooth modern finishes.", span: 1 },
  { slug: "texture-repair", title: "Texture Repair", icon: "Grid3X3", description: "Knockdown, orange peel, smooth — invisible repairs that blend perfectly.", span: 1 },
  { slug: "caulking-sealing", title: "Caulking & Sealing", icon: "Pipette", description: "Watertight seals on windows, joints and trim. Long-lasting protection.", span: 1 },
  { slug: "screen-enclosure-painting", title: "Screen Enclosure Painting", icon: "Frame", description: "Refresh and protect lanai and pool enclosures with specialty coatings.", span: 1 },
  { slug: "garage-painting", title: "Garage Painting", icon: "Warehouse", description: "Walls, ceilings and floor coatings for a clean, durable garage.", span: 1 },
  { slug: "home-design-services", title: "Home Design Services", icon: "Compass", description: "Color consults, finish selections and design direction for cohesive interiors.", span: 2 },
];

export const TESTIMONIALS = [
  {
    name: "Jennifer M.",
    location: "Wesley Chapel, FL",
    rating: 5,
    service: "Interior & Exterior Painting",
    quote:
      "Santos and his crew transformed our entire home — inside and out. The attention to detail on the trim and cabinets was unbelievable. Worth every penny and they finished a day early.",
  },
  {
    name: "Daniel R.",
    location: "Lutz, FL",
    rating: 5,
    service: "Stucco Repair",
    quote:
      "We had years-old cracks running along the entire west wall. Zelaya's matched the texture so perfectly you cannot tell where the repair was. True professionals.",
  },
  {
    name: "Patricia G.",
    location: "Tampa, FL",
    rating: 5,
    service: "Kitchen Remodel",
    quote:
      "From the first estimate to the final walkthrough, communication was outstanding. The new kitchen is stunning. Honest pricing, clean job site, and a 1-year warranty that gives us peace of mind.",
  },
  {
    name: "Michael S.",
    location: "Land O' Lakes, FL",
    rating: 5,
    service: "Cabinet Painting",
    quote:
      "I priced out a few contractors — Zelaya's was the only one who actually showed up, took the time to explain the process, and delivered on every promise. Cabinets look brand new.",
  },
  {
    name: "Elena V.",
    location: "Wesley Chapel, FL",
    rating: 5,
    service: "Pressure Washing & Exterior",
    quote:
      "Our HOA inspection was coming up and Santos squeezed us in. House looks better than the day we bought it. Highly recommend.",
  },
  {
    name: "Carlos H.",
    location: "Zephyrhills, FL",
    rating: 5,
    service: "New Stucco",
    quote:
      "Crew was respectful, on time every day and the workmanship is incredible. We've already referred them to two neighbors.",
  },
];

export const GALLERY_CATEGORIES = [
  { key: "all", label: "All Projects" },
  { key: "before-after", label: "Before & After" },
  { key: "interior", label: "Interior" },
  { key: "exterior", label: "Exterior" },
  { key: "stucco", label: "Stucco" },
  { key: "remodeling", label: "Remodeling" },
  { key: "recent", label: "Recent Jobs" },
];

// Curated stock images for initial gallery
export const STOCK_GALLERY = [
  { id: "s1", title: "Modern Luxury Living Room", category: "interior", image_url: "https://images.unsplash.com/photo-1613545325278-f24b0cae1224?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85", description: "Full interior repaint with custom accent wall." },
  { id: "s2", title: "Coastal Exterior Refresh", category: "exterior", image_url: "https://images.unsplash.com/photo-1706855203772-c249b75fe016?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85", description: "Full exterior repaint with stucco repair." },
  { id: "s3", title: "Designer Kitchen Remodel", category: "remodeling", image_url: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85", description: "Full remodel — cabinets, paint, and finishes." },
  { id: "s4", title: "Stucco Patch & Re-coat", category: "stucco", image_url: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85", description: "Hairline crack repair, color-matched finish." },
  { id: "s5", title: "Cabinet Refinish", category: "interior", image_url: "https://images.unsplash.com/photo-1556910103-1c02745aae4d?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85", description: "Factory-grade cabinet refinishing." },
  { id: "s6", title: "Master Suite Repaint", category: "interior", image_url: "https://images.unsplash.com/photo-1505691938895-1758d7feb511?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85", description: "Walls, ceilings & trim — luxury matte finish." },
  { id: "s7", title: "Driveway Pressure Wash", category: "recent", image_url: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85", description: "Like-new finish on driveway and walkway." },
  { id: "s8", title: "Lanai Enclosure Refinish", category: "exterior", image_url: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85", description: "Specialty coating on screen enclosure frame." },
  { id: "s9", title: "Modern Bath Remodel", category: "remodeling", image_url: "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85", description: "Tile, paint, fixtures, & lighting." },
];

export const BEFORE_AFTER = {
  before: "https://images.unsplash.com/photo-1600566752355-35792bedcfea?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
  after: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
};

export const OWNER_PORTRAIT =
  "https://static.prod-images.emergentagent.com/jobs/6883c21e-0187-4b91-826f-81673c17befb/images/69d519690d80934329b489aebf6a8398c32dc3c46bb21fda4ca94a990e57e26a.png";

export const HERO_BG =
  "https://images.unsplash.com/photo-1706855203772-c249b75fe016?crop=entropy&cs=srgb&fm=jpg&w=2000&q=85";

export const ABOUT_BG =
  "https://images.unsplash.com/photo-1613545325278-f24b0cae1224?crop=entropy&cs=srgb&fm=jpg&w=2000&q=85";
